import { DateOptions, IConfiguredTrafficReport } from "./IConfiguredTrafficReport";
import { AggregationPeriod } from "@app/shared";
import { downloadCSV, TotalVolumeDataLoader } from "./TotalVolumeDataLoader";

export const TotalVolumeByHour: IConfiguredTrafficReport = {
    name: "by Hour",
    key: "tvh",
    description: "This report shows total traffic by hour for the given range",
    component: props => (<TotalVolumeDataLoader {...props} aggregationPeriod={AggregationPeriod.Hour} />),
    defaultChartType: 'line',
    defaultRange: DateOptions.LastWeek,
    downloadData: opts => downloadCSV(AggregationPeriod.Hour, opts),
    config: {
        requiresMonth: false,
        allowsCustomRange: true,
        allowTargetTypeGrouping: true,
        requiresYear: false
    }
};